import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** 复制文本 */
export function copyText(text: string) {
  const input = document.createElement("input");
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}

/** 下载文件 */
export async function downloadFile(url: string, fileName: string) {
  const data = await fetch(url).then((res) => res.arrayBuffer());

  const blob = new Blob([data], { type: "application/pdf" });
  const downloadUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/** 下载Excel文件 */
export async function downloadExcelFile(data: ArrayBuffer, fileName: string) {
  const blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const downloadUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// 通过a标签预览PDF
export async function previewPdf(url: string, title: string) {
  const link = document.createElement("a");
  link.href = url;
  link.download = title;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/** 获取文件后缀名 */
export function getSuffixByFileName(fileName: string) {
  const arr = fileName.split(".");
  return arr[arr.length - 1];
}

/** 获取文件下载地址 */
export function getFileDownloadAdress(id: string) {
  return `${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${id}`
}

/** 获取小数位数 */
export function getDecimals(value: number) {
  if (!value || isNaN(value)) {
    return 0;
  }
  const decimalString = String(value).split(".")[1] || "";
  return decimalString.length;
}

